import React, { Component } from 'react';
import { Badge, Button, DropdownItem, DropdownMenu, DropdownToggle, Nav, NavItem } from 'reactstrap';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import Http from "../../services/Http";
import apiPath from "../../constants/apiPath";
import _ from "lodash";
import { AppHeaderDropdown, AppNavbarBrand, AppSidebarToggler } from '@coreui/react';
import logo from '../../assets/img/brand/gamony-wordmark.svg'
import sygnet from '../../assets/img/brand/gamony-icon.svg'
import PubNubReact from 'pubnub-react';
import connect from "react-redux/es/connect/connect";
import { adminLogin } from "../../actions/index";
import soundfile from '../../assets/img/alert.mp3'
import Sound from 'react-sound'
import { isWithdrawalEmployee } from '../../accessControl';

const pubnubPublishKey = "";
const pubnubSubscribeKey = "";

const mapStateToProps = state => {
  return { admin: state.admin };
};

const mapDispatchToProps = dispatch => {
  return {
    adminLogin: admin => dispatch(adminLogin(admin))
  };
};

const propTypes = {
  children: PropTypes.node,
};

const defaultProps = {};

class DefaultHeader extends Component {

  constructor(props) {
    super(props);
    this.pubnub = new PubNubReact({
      publishKey: pubnubPublishKey,
      subscribeKey: pubnubSubscribeKey
    });
    this.state = {
      unreadNoti: 0,
      notificationsCount: 0,
      notifications: [],
    }
    this.pubnub.init(this);
    this.onLogoutHandle = this.onLogoutHandle.bind(this);
    this.closePopup = this.closePopup.bind(this);
  }


  closePopup = event => {
    console.log(event.currentTarget);
    var cT = event.currentTarget;
    cT.parentNode.remove();
  }
  componentWillUnmount() {
    this.pubnub.unsubscribe({
      channels: [""]
    });

  }
  componentDidMount() {
    //this.getAdminNotifications();
    this.interval = setInterval(() => this.tick(), 6000);
  }

  async getAdminNotifications() {
    let path = apiPath.getAdminNotifications;
    let options = {
      method: 'GET',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }
    }
    let result = await Http(path, options);
    if (result.ok) {
      if (result.status === 200) {
        let resultData = await result.json();
        if (resultData.success) {
          this.setState({ notifications: resultData.result, notificationsCount: resultData.notificationsCount })
        }
      }
    } else {
      console.log(result);
    }
  }
  tick() {
    //this.getAdminNotifications();
  }

  async onLogoutHandle() {
    if (!window.confirm("Are you sure to logout?")) {
      return false;
    } else {
      let path = apiPath.adminLogout;
      let options = {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }
      }
      let result = await Http(path, options);
      //if (result.status === 200) { }   
      localStorage.removeItem("admin");
      localStorage.setItem("redirect", (this.props.admin.account_type === 'admin') ? "/login" : '/login');
      this.props.adminLogin({});
      window.location.reload();

    }
  }
  notifications() {
    if (!_.isEmpty(this.state.notifications)) {
      return this.state.notifications.map((make, index) => {
        return <DropdownItem className={make.is_read ? 'notification-item  notification-read' : 'notification-item'} >
          <div className="notification-content"><p className="notification-title">{make.title}</p>
            <p>{make.description}</p></div>
          <Button className="notification-delete btn btn-outline-info" onClick={this.deleteNotification.bind(this, make.id)}><i class="fa fa-trash" aria-hidden="true"></i></Button>
        </DropdownItem>
      })
    }
  }
  async deleteNotification(notificationId) {
    let path = apiPath.deleteNotification;
    var data = new FormData();
    data.append('notificationId', notificationId);
    let options = {
      method: 'POST',
      headers: {},
      body: data
    }
    let result = await Http(path, options);
    if (result.ok) {
      if (result.status === 200) {
        let resultData = await result.json();
        if (resultData.success) {
          this.getAdminNotifications();
        }
      }
    } else {
      console.log(result);
    }
  }
  render() {
    // eslint-disable-next-line
    const { children, ...attributes } = this.props;
    return (
      <React.Fragment>
        <AppSidebarToggler className="d-lg-none" display="md" mobile aria-label="Toggle navigation" />
        <AppNavbarBrand
          full={{ src: logo, alt: 'Gamony Logo', width: 160, height: 36 }}
          minimized={{ src: sygnet, alt: 'Gamony Logo', width: 32, height: 32 }}
        />
        <AppSidebarToggler className="d-md-down-none" display="lg" aria-label="Toggle navigation" />
        <span className="gamony-shell-title">{isWithdrawalEmployee(this.props.admin) ? 'Employee Operations' : 'Gamony Admin'}</span>
        <Nav className="ml-auto bell-icon-custom" navbar>
          {!isWithdrawalEmployee(this.props.admin) && <AppHeaderDropdown direction="down">
            <DropdownToggle nav aria-label="Notifications">
              <i className="icon-bell" aria-hidden="true"></i><span className="notification-counter">{this.state.notificationsCount}</span>
            </DropdownToggle>
            <DropdownMenu className="notification-items" right style={{ right: 'auto' }}>
              {this.state.notifications?.length ?
                this.notifications()
                : <DropdownItem>No record found</DropdownItem>}

            </DropdownMenu>
          </AppHeaderDropdown>}
          <AppHeaderDropdown direction="down">
            <DropdownToggle nav aria-label="Account menu" className="gamony-account-menu">
              {/*<img src={'assets/img/avatars/6.jpg'} className="img-avatar" alt="admin@bootstrapmaster.com" />*/}
              <span className="setting_icon"><i className="fa fa-user" aria-hidden="true"></i></span>
              <span className="gamony-account-name">{this.props.admin.first_name || this.props.admin.username}</span>
            </DropdownToggle>
            <DropdownMenu right style={{ right: 'auto' }}>
              <DropdownItem header tag="div" className="text-center"><strong>{_.upperFirst(this.props.admin.username)} · {isWithdrawalEmployee(this.props.admin) ? 'Withdrawal employee' : 'Admin'}</strong></DropdownItem>
              {!isWithdrawalEmployee(this.props.admin) && <DropdownItem tag={Link} to={"profile"}><i className="fa fa-user"></i> Profile</DropdownItem>}
              <DropdownItem tag={Link} to={"logout"} onClick={this.onLogoutHandle}><i className="fa fa-lock"></i>Logout</DropdownItem>
            </DropdownMenu>
          </AppHeaderDropdown>
        </Nav>
      </React.Fragment>
    );
  }
}

DefaultHeader.propTypes = propTypes;
DefaultHeader.defaultProps = defaultProps;
export default connect(mapStateToProps, mapDispatchToProps)(DefaultHeader);
